import React, {PureComponent as Component} from 'react';

import {BrowserRouter as Router, Switch, Route  } from 'react-router-dom';
import queryString from 'query-string';
import Login from "./Controllers/Auth/Login";
import Home from "./Controllers/Home/Home";
import Page404 from "./Controllers/Errors/Page404";
import Auth from "./Before/Auth";
import authorize from "./Controllers/Auth/Api/Authorize";
import Loading from "../ui/template/Loading/Loading";
import {XBr, XDiv, XSpan} from "../ui/template/Layout/Layout";
import { MCbrowser } from './Context/browserContext';

class Routing extends Component{

    constructor(props) {
        super(props);
        this.state = { loaded: false , isLoggedIn: false };
        this.handleLogged = this.logged.bind(this);
        this.handleLogout = this.logout.bind(this);
        this.handleInitAuth = this.initAuth.bind(this);
        this.props = props;
        this.callmode="";
        const  search  = window.location.search;
        const qusValues = queryString.parse(search);
        if (Boolean(qusValues.callmode)) {
            this.callmode = qusValues.callmode;
        }
        this._asyncRequest = null;
    }

    logged() {
        localStorage.setItem('loggedIn', true);
        this.setState({isLoggedIn: true});
    }

    logout() {
        localStorage.removeItem('loggedIn');
        localStorage.setItem('allValidations',"");
        this.setState({isLoggedIn: false});
    }

    initAuth(isLoggedIn) {
        this.setState({loaded: true,isLoggedIn: isLoggedIn});
    }

    componentDidMount() {
        if (this.state.loaded===false) {
            const hAuth=this.handleInitAuth;
            authorize().then(response => {
                hAuth(response);
            });
        }
    }

    render() {
        this.context.isLoggedIn=this.state.isLoggedIn;
        if (this.state.loaded) {
            if (!this.state.isLoggedIn) {
                if(this.callmode ==="iframe"){
                    return <XDiv className="text-center w-100 p-5 font-size-15 " ><XSpan>
                        کاربر
                        گرامی ابتدا به پنل نرم افزار ورود کنید.
                        <XBr /> <XBr />
                        سپس مجدداً تلاش کنید.
                    </XSpan></XDiv>;
                }else{
                    return <Login logged={this.handleLogged} />;
                }
            }

            return ( 
                <Router  >
                    <Switch>
                        <Route exact path="/auth/login">
                            <Login logged={this.handleLogged} />
                        </Route>
                        <Route path="/membership">
                            <Auth logout={this.handleLogout} />
                        </Route>
                        <Route exact path="/">
                            <Home/>
                        </Route>
                        <Route path="*">
                            <Page404/>
                        </Route>
                    </Switch>
                </Router>
            );
        }else {
            return (
                <Loading type="Chase" />
            );
        }
    }

    componentWillUnmount() {
        if (this._asyncRequest) {
            this._asyncRequest.cancel();
        }
    }

}
Routing.contextType = MCbrowser;
export default Routing;
